import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ROLES_FEATURE_KEY,
  rolesAdapter,
  RolesPartialState,
  RoleState,
} from './roles.reducer';
import { hasRole } from '@boma/shared/common';
import { RoleAuthTarget } from '@boma/client-shared';

// Lookup the 'Roles' feature state managed by NgRx
export const getRolesState = createFeatureSelector<
  RolesPartialState,
  RoleState
>(ROLES_FEATURE_KEY);

const { selectAll, selectEntities } = rolesAdapter.getSelectors();

export const getEntityRoles = createSelector(getRolesState, (state) =>
  // @ts-ignore
  selectAll(state).filter(
    (r) => (r.target & RoleAuthTarget.Entity) === RoleAuthTarget.Entity
  )
);

export const getLocationRoles = createSelector(getRolesState, (state) =>
  // @ts-ignore
  selectAll(state).filter(
    (r) => (r.target & RoleAuthTarget.Location) === RoleAuthTarget.Location
  )
);

export const getVehicleRoles = createSelector(getRolesState, (state) =>
  // @ts-ignore
  selectAll(state).filter(
    (r) => (r.target & RoleAuthTarget.Vehicle) === RoleAuthTarget.Vehicle
  )
);

export const getAssignedAdminRoles = createSelector(
  getRolesState,
  (state: RoleState) => state.assignedAdminRoles
);

export const isModifyingRoles = createSelector(
  getRolesState,
  (state: RoleState) => state.isCreatingOrUpdatingRoles
);

export const isApplyingRoles = createSelector(
  getRolesState,
  (state: RoleState) => state.isApplyingRoles
);

export const getRolesLoaded = createSelector(
  getRolesState,
  (state: RoleState) => state.loaded
);

export const getRolesError = createSelector(
  getRolesState,
  (state: RoleState) => state.error
);

export const getAllRoles = createSelector(getRolesState, (state: RoleState) =>
  selectAll(state)
);

export const getRolesEntities = createSelector(
  getRolesState,
  (state: RoleState) => selectEntities(state)
);

export const getSelectedRoleId = createSelector(
  getRolesState,
  (state: RoleState) => state.selectedId
);

export const getSelectedRole = createSelector(
  getRolesEntities,
  getSelectedRoleId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
